import React from 'react';
import { CheckCircle2, Download, FileText, FileSpreadsheet, Loader2, Trash2, XCircle, CalendarRange } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Progress } from '@/components/ui/progress';
import { API } from '@/components/resource-library/resourceLibraryApi';
import { STATUS_STYLE } from './courseGenMeta';

export const JobCard = ({ job, onDelete, onOpenPlanner }) => {
  const token = localStorage.getItem('authToken');
  const running = job.status === 'running' || job.status === 'queued';
  const files = (job.outputs || []).filter((o) => o.resource_id);
  const planner = (job.outputs || []).find((o) => o.category === 'planning_workbook');
  return (
    <div className="rounded-xl border bg-white p-4 shadow-sm space-y-3" data-testid={`job-card-${job.id}`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="font-semibold text-slate-900">Year {job.year_level} {job.subject}</div>
          <div className="text-xs text-slate-500">{new Date(job.created_at).toLocaleString()} · {(job.doc_types || []).length} document type(s)</div>
        </div>
        <div className="flex items-center gap-2">
          <Badge className={STATUS_STYLE[job.status] || ''} data-testid={`job-status-${job.id}`}>{job.status}</Badge>
          {!running && (
            <Button size="icon" variant="ghost" onClick={() => onDelete(job)} data-testid={`job-delete-${job.id}`}><Trash2 className="h-4 w-4 text-slate-400" /></Button>
          )}
        </div>
      </div>
      {running && (
        <div className="space-y-1">
          <Progress value={job.progress || 0} className="h-2" />
          <div className="flex items-center gap-2 text-xs text-amber-800"><Loader2 className="h-3 w-3 animate-spin" />{job.step}</div>
        </div>
      )}
      {job.status === 'failed' && <div className="flex items-start gap-2 text-sm text-red-700"><XCircle className="h-4 w-4 mt-0.5" />{job.error || 'Generation failed'}</div>}
      {job.status === 'done' && (
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm text-emerald-700"><CheckCircle2 className="h-4 w-4" />{job.outline?.chapter_count} chapters · saved to the Resource Library</div>
          <div className="flex flex-wrap gap-2">
            {files.map((o) => (
              <a key={o.resource_id} href={`${API}/api/resource-library/files/${o.resource_id}?token=${token}&download=1`} target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs hover:bg-slate-50" data-testid={`job-file-${o.resource_id}`}>
                {o.format === 'pdf' ? <FileText className="h-3 w-3 text-red-500" /> : <FileSpreadsheet className="h-3 w-3 text-blue-600" />}
                {o.label} · {o.format.toUpperCase()} <Download className="h-3 w-3 text-slate-400" />
              </a>
            ))}
            {planner && (
              <button type="button" onClick={() => onOpenPlanner(job)} className="inline-flex items-center gap-1 rounded-md border border-amber-300 bg-amber-50 px-2 py-1 text-xs hover:bg-amber-100" data-testid={`job-planner-${job.id}`}>
                <CalendarRange className="h-3 w-3 text-amber-700" /> Interactive Planner · {planner.lessons} lessons
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
